export class MapWithDefault<K, V> {
  constructor(
    private readonly innerMap: Map<K, V>,
    private readonly fallbackKey: K,
  ) {}

  public getOrDefault(key: K): V {
    return this.innerMap.get(key) ?? this.innerMap.get(this.fallbackKey)!;
  }
}
